import axios from 'axios';
import { BAD_REQUEST, CommonResult, INTERNAL_SERVER_ERROR, OK, ConditionItem } from '../Common';
import { API_EXCEPTION_MSG } from '../../Common';

const endpoint = process.env.REACT_APP_API_URL;
const url = `${endpoint}/condition`;

export interface ConditionsGetApiRequest {
  userId: string;
}

export interface SearchConditions {
  searchConditionId: string;
  searchConditionName: string;
  searchBranch: ConditionItem[];
}

export interface ConditionsGetApiResponse {
  result: CommonResult;
  searchConditions?: SearchConditions[];
}

/**
 * 検索条件取得API
 * @param request リクエスト
 */
export async function conditionsGetApi(request: ConditionsGetApiRequest): Promise<ConditionsGetApiResponse> {
  try {
    const response = await axios.get<ConditionsGetApiResponse>(`${url}?userId=${request.userId}`);
    const data = response.data;
    const status = response.status;

    switch (status) {
      case OK.status:
        return data;
      case BAD_REQUEST.status:
        return data;
      case INTERNAL_SERVER_ERROR.status:
        throw new Error(data.result.resultCd);
      default:
        throw new Error('9999');
    }
  } catch (error) {
    const errCode = error.message;
    return {
      result: {
        jobDateTime: '',
        resultCd: '9999',
        resultMessageDtoList: [
          {
            resultMessageCd: '9999',
            resultMessage: `${API_EXCEPTION_MSG} エラーコード:${errCode}`,
          },
        ],
      },
    };
  }
}
